import { render, staticRenderFns } from "./FundingRounds.vue?vue&type=template&id=721bf734"
import script from "./FundingRounds.vue?vue&type=script&lang=js"
export * from "./FundingRounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports